import { Inject } from '@odinjs/odin';

import { Route } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FormAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnChange, OnMount } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent, FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService } from '@philips-emr/tws-core/lib/services';

import { HistoricoSolicitacoesAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

enum CONTROLE_ACESSO {
  DATA_ADMISSAO = 2,
  ALTERACAO_CADASTRAL = 3,
  ALTERACAO_LOCALIZACAO = 4,
  ALTERACAO_MATRICULA = 5,
  ALTERACAO_PRODUTO = 6,
  ALTERACAO_VINCULOS = 7,
  MIGRACAO_CONTRATOS = 8,
  COMPARTILHAMENTO_RISCO = 10,
  SEGUNDA_VIA_CARTAO = 11,
  TRASF_TITULARIDADE = 12,
  BENEFICIARIO_INCLUSAO = 14,
  ALTERACAO_SUBESTIPULANTE = 17,
}

const rotas: Map<number, string> = new Map([
  [CONTROLE_ACESSO.DATA_ADMISSAO, Route.CONSULTA_ALTERAR_DATA_ADMIMISSAO],
  [CONTROLE_ACESSO.ALTERACAO_CADASTRAL, Route.CONSULTA_ALTERAR_CADASTRO],
  [CONTROLE_ACESSO.ALTERACAO_LOCALIZACAO, Route.CONSULTA_ALTERAR_LOCALIZACAO],
  [CONTROLE_ACESSO.ALTERACAO_MATRICULA, Route.CONSULTA_ALTERAR_MATRICULA],
  [CONTROLE_ACESSO.ALTERACAO_VINCULOS, Route.CONSULTA_ALTERAR_VINCULO],
  [CONTROLE_ACESSO.MIGRACAO_CONTRATOS, Route.CONSULTA_MIGRAR_CONTRATO],
  [CONTROLE_ACESSO.BENEFICIARIO_INCLUSAO, Route.CONSULTA_INCLUSAO_BENEFICIARIO],
  [CONTROLE_ACESSO.COMPARTILHAMENTO_RISCO, Route.CONSULTA_COMPARTILHAMENTO_RISCO],
  [CONTROLE_ACESSO.SEGUNDA_VIA_CARTAO, Route.CONSULTA_STATUS_SEGUNDA_VIA],
  [CONTROLE_ACESSO.TRASF_TITULARIDADE, Route.CONSULTA_TRANSFERENCIA_TITULARIDADE],
  [CONTROLE_ACESSO.ALTERACAO_SUBESTIPULANTE, Route.CONSULTA_ALTERAR_SUBESTIPULANTE],
  [CONTROLE_ACESSO.ALTERACAO_PRODUTO, Route.CONSULTA_ALTERAR_PRODUTO],
]);

@Controller({ fragment: FragmentNames.HISTORICO_SOLICITACOES })
class ConsultarAlteracoesVinculoController extends BaseController {

  @Inject(Aliases.FORM_MENU)
  private formMenu: FormAPI;

  @OnMount(Aliases.FETCH_MENU)
  onMountFetchMenu(event: MountEvent): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqContrato });
    api.forceFetch();
  }

  @OnChange(Aliases.FIELD_MENU)
  onChangeMenu(event: ChangeEvent<number>): void {
    const rota = rotas.get(event.value);
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    if (rota) {
      this.historyService.push(rota, { nrSeqGrupoContratoWeb, nrSeqContrato });
    }
  }

  @OnAfterFetch(Aliases.FETCH_MENU)
  onAfterFetchMenu(event: FetchEvent): void {
    const data = event.data as Record<string, Value>[];
    if (data) {
      const { nrSequencia } = data[0];
      const route = rotas.get(nrSequencia as number);

      this.formMenu.setData({ nrSeqMenu: nrSequencia });

      if (route) {
        this.historyService.push(route);
      }
      console.log(route);

    }
  }

}

export default ConsultarAlteracoesVinculoController;
